export default __webpack_public_path__ + "static/ti-9e1c2b193758db9d7f1cdac3b2cebc18.svg";